export interface BrowserInfo {
  name: string;
  version: number;
  isChrome: boolean;
  isEdge: boolean;
  isPipSupported: boolean;
  isPipCompatible: boolean; // Chrome/Edge 116+
}

export const getBrowserInfo = (): BrowserInfo => {
  const userAgent = navigator.userAgent;
  let name = 'Unknown';
  let version = 0;
  let isChrome = false;
  let isEdge = false;

  // Detect Chromium-based Edge (must check before Chrome)
  if (userAgent.indexOf('Edg/') > -1) {
    isEdge = true;
    name = 'Microsoft Edge';
    const match = userAgent.match(/Edg\/(\d+)/);
    version = match ? parseInt(match[1], 10) : 0;
  }
  // Detect Chrome (check after Edge since Edge also has Chrome in UA)
  else if (
    userAgent.indexOf('Chrome/') > -1 &&
    userAgent.indexOf('Edg/') === -1
  ) {
    isChrome = true;
    name = 'Chrome';
    const match = userAgent.match(/Chrome\/(\d+)/);
    version = match ? parseInt(match[1], 10) : 0;
  }
  // Detect Firefox
  else if (userAgent.indexOf('Firefox/') > -1) {
    name = 'Firefox';
    const match = userAgent.match(/Firefox\/(\d+)/);
    version = match ? parseInt(match[1], 10) : 0;
  }
  // Detect Safari (check that it's not Chrome/Edge)
  else if (
    userAgent.indexOf('Safari/') > -1 &&
    userAgent.indexOf('Chrome') === -1
  ) {
    name = 'Safari';
    const match = userAgent.match(/Version\/(\d+)/);
    version = match ? parseInt(match[1], 10) : 0;
  }
  // Detect Opera
  else if (userAgent.indexOf('OPR/') > -1) {
    name = 'Opera';
    const match = userAgent.match(/OPR\/(\d+)/);
    version = match ? parseInt(match[1], 10) : 0;
  }

  // Check if Document Picture-in-Picture API is available
  const isPipSupported = 'documentPictureInPicture' in window;

  // Check if browser version meets minimum requirements (Chrome/Edge 116+)
  const isPipCompatible = (isChrome || isEdge) && version >= 116;

  return {
    name,
    version,
    isChrome,
    isEdge,
    isPipSupported,
    isPipCompatible,
  };
};

export const getPipStatusMessage = (browserInfo: BrowserInfo): string => {
  if (browserInfo.isPipSupported && browserInfo.isPipCompatible) {
    return '';
  }

  if (!browserInfo.isChrome && !browserInfo.isEdge) {
    return `Floating Window not available in ${browserInfo.name}. Please use Chrome or Edge browser (version 116+).`;
  }

  if (browserInfo.version < 116) {
    return `Floating Window requires ${browserInfo.name} version 116+. You are using version ${browserInfo.version}.`;
  }

  return `Floating Window not available in your browser.`;
};
